import { createSelector } from '@reduxjs/toolkit';

import { InsertionWorkLine } from '../../library/layout-geometry/work-lines';
import { RootState } from '../index';

export const getWorkLineInsertionInfo = createSelector(
  (state: RootState) => state.application.insertingObjectInfo,
  (insertingObjectInfo) => (insertingObjectInfo?.type === 'workLine' ? insertingObjectInfo : null),
);

export function getIsInsertingWorkLine(state: RootState): boolean {
  return state.application.insertingObjectInfo?.type === 'workLine';
}

export function getInsertionWorkLineType(state: RootState): InsertionWorkLine['type'] | null {
  const info = state.application.insertingObjectInfo;
  if (info?.type !== 'workLine') return null;

  if (info.draft.phase === 'reviewing') return info.draft.line.type;
  if (info.draft.phase === 'gesturing') return info.liveGestureLineType;

  return null;
}
